import API from "serviceshift-ui/api-client";

export default {
  async archiveWarrantyTodo(_, link) {
    return API.makeRequest(link, { method: "PUT" })
  },

  /**
   * 
   * @param _
   * @param link string
   * @param warranty {{
   *   equipment_id:number,
   *   warranty_program_id: number,
   *   purchase_date: string,
   *   effective_date: string,
   *   expiration_date: string
   * }}
   */
  async completeWarrantyTodo(_, { link, warranty }) {
    return API.makeRequest(link, { 
      method: "PUT", 
      data: { warranty }
    })
  }
};
